export default __webpack_public_path__ + "fe7f83abbc33795c55d5bbab3ab117f3.png";